var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-hamburger btn btn-link btn--hamburger",class:[{ collapsed: !_vm.mobileMenuShow }],on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"c-hamburger--top"}),_c('span',{staticClass:"c-hamburger--middle"}),_c('span',{staticClass:"c-hamburger--bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }